import { defineMessage } from 'services/localization';

export const messages = {
    bankAccountName: defineMessage('account_name_1'),
    bankAccountCountry: defineMessage('country_1'),
    bankAccountCurrency: defineMessage('currency_2'),
    bankAccountSortCode: defineMessage('sort_code_1'),
    bankAccountNumber: defineMessage('account_number_1'),
    previous: defineMessage('previous'),
    actual: defineMessage('actual'),
    ukCountry: defineMessage('uk'),
};
